// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hgPromoWrapper[data-v-c199d26a]{display:flex;flex-direction:row;gap:1.25rem;height:22.5rem;margin:0 auto;max-width:1400px;padding:0 1.5rem}.hgPromoWrapper a[data-v-c199d26a]:first-child,.hgPromoWrapper a[data-v-c199d26a]:nth-child(2){width:100%}@media (max-width:768px){.hgPromoWrapper[data-v-c199d26a]{flex-direction:column;height:-moz-fit-content;height:fit-content;margin:0 1rem;padding:0}.hgPromoWrapper a[data-v-c199d26a]{height:20rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
